module.exports = __webpack_public_path__ + "li.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/li.svg
// module id = 915
// module chunks = 0